import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
import { getUser } from "../../../utils/commonfunction";

const getActiveRole = () => {
    const roles = [ROLE.SUPER_ADMIN, ROLE.SUB_ADMIN, ROLE.CLUB_ADMIN, ROLE.PLAYER, ROLE.PARENT, ROLE.NON_AFFILIATED_USER];
    for (const r of roles) {
        const u = getUser(r);
        if (u && u.token) return r;
    }
    return ROLE.SUPER_ADMIN;
};

class ClubBillingService {
    signAgreement = async (data) => {
        return await axiosInstance({ role: getActiveRole() }).post(`club-admin/billing/sign-agreement`, data);
    };

    setupCheckout = async () => {
        return await axiosInstance({ role: getActiveRole() }).post(`club-admin/billing/setup-checkout`);
    };

    verifySetup = async (session_id) => {
        return await axiosInstance({ role: getActiveRole() }).post(`club-admin/billing/verify-setup`, { session_id });
    };

    generateTestInvoice = async () => {
        return await axiosInstance({ role: getActiveRole() }).post(`club-admin/billing/generate-test-invoice`);
    };

    createPortalSession = async (returnUrl) => {
        return await axiosInstance({ role: getActiveRole() }).post(`club-admin/billing/customer-portal`, { returnUrl });
    };

    getStatus = async () => {
        return await axiosInstance({ role: getActiveRole() }).get(`club-admin/billing/status`);
    };

    downloadAgreement = async () => {
        return await axiosInstance({ role: getActiveRole() }).get(`club-admin/billing/agreement`);
    };
}

export default new ClubBillingService();
